// @ts-nocheck
import 'src/styles/webapp/legacy-styles.scss';
import 'src/styles/webapp/sprites.scss';
import DOMPurify from 'isomorphic-dompurify';

(function () {
  ('use strict');
  var strings = {
    en: {
      skill_successfully_linked:
        'Your <span class="skillName"></span> Skill was successfully linked.',
      attempting_to_link_skill:
        'Attempting to link your <span class="skillName"></span> Skill.',
      unable_to_link_skill:
        'Unable to link your <span class="skillName"></span> Skill.',
      please_try_again: 'Please try again later.',
      leave_this_page: 'You can now leave this page',
    },
    de: {
      skill_successfully_linked:
        'Ihr <span class="skillName"></span> Skill wurde erfolgreich verkn&#x00fc;pft.',
      attempting_to_link_skill:
        'Es wird versucht, Ihren <span class="skillName"></span> Skill zu verkn&#x00fc;pfen.',
      unable_to_link_skill:
        'Ihr <span class="skillName"></span> Skill kann nicht verkn&#x00fc;pft werden.',
      please_try_again: 'Bitte versuchen Sie es sp&#x00e4;ter erneut.',
      leave_this_page: 'Sie k&#x00f6;nnen diese Seite jetzt verlassen',
    },
    es: {
      skill_successfully_linked:
        'Tu <span class="skillName"></span> se conect&#xf3; exitosamente.',
      attempting_to_link_skill:
        'Estamos intentando conectar tu Skill <span class="skillName"></span>.',
      unable_to_link_skill:
        'No pudimos conectar tu Skill <span class="skillName"></span>.',
      please_try_again: 'Por favor int&#xe9;ntalo de nuevo m&#xe1;s tarde.',
      leave_this_page: 'Ahora puedes salir de esta p&#xe1;gina.',
    },
    ja: {
      skill_successfully_linked:
        '<span class="skillName"></span>スキルがリンクされました。',
      attempting_to_link_skill:
        '<span class="skillName"></span>スキルをリンクしています。',
      unable_to_link_skill:
        '<span class="skillName"></span>スキルをリンクできません。',
      please_try_again: '後でもう一度試してみてください。',
      leave_this_page: 'このページを閉じても問題ありません。',
    },
    it: {
      skill_successfully_linked:
        'La tua Skill <span class="skillName"></span> è stata collegata con successo.',
      attempting_to_link_skill:
        'Tentativo di collegamento della tua Skill <span class=”skillName”></span>.',
      unable_to_link_skill:
        'Impossibile collegare la tua Skill <span class=”skillName”></span>.',
      please_try_again: 'Riprova più tardi.',
      leave_this_page: 'Ora puoi abbandonare la pagina',
    },
    fr: {
      skill_successfully_linked:
        'Votre Skill <span class="skillName"></span> a été associée.',
      attempting_to_link_skill:
        'Tentative d\'association de votre Skill <span class="skillName"></span>.',
      unable_to_link_skill:
        'Impossible d\'associer votre Skill <span class="skillName"></span>.',
      please_try_again: 'Veuillez réessayer ultérieurement.',
      leave_this_page: 'Vous pouvez maintenant quitter cette page',
    },
  };

  // Takes in a list of vars which should be formatted as a key value pair separated
  // by an equals sign. This method then finds the key and returns the value after the equals sign.
  function findKeyAndReturnValue(input, key) {
    var vars = input.split('&'),
      i;
    for (i = 0; i < vars.length; i++) {
      // Find the first = sign and split it from there.
      var firstEqualsIndex = vars[i].indexOf('=');
      if (firstEqualsIndex > 0) {
        if (key === vars[i].substr(0, firstEqualsIndex)) {
          return vars[i].substr(firstEqualsIndex + 1);
        }
      }
    }
    return false;
  }

  function getLanguage() {
    // check the url first to see lang=XXX is set in url
    let query, hash;
    if(DOMPurify.sanitize(window.location.search)) {
      query = DOMPurify.sanitize(window.location.search).substring(1);
    }
    if(DOMPurify.sanitize(window.location.hash)) {
      hash = DOMPurify.sanitize(window.location.hash).substring(1);
    }
    var language =
      findKeyAndReturnValue(hash, 'lang') ||
      findKeyAndReturnValue(query, 'lang') ||
      '';
    if (language) {
      language = language.toLowerCase();
      language = language.replace('_', '-');
      if (strings[language]) {
        return language;
      }
      language = language.split('-')[0];
      if (strings[language]) {
        return language;
      }
    }

    // if nothing found, use the browser lang
    language = navigator.language.toLowerCase();
    if (strings[language]) {
      return language;
    }
    language = language.split('-')[0];
    if (strings[language]) {
      return language;
    }
    return 'en';
  }

  function getString(string) {
    var language = getLanguage();
    return strings[language] && strings[language][string];
  }

  function setString(id, string) {
    var el = document.getElementById(id);
    if (el) {
      const cleanHtml = DOMPurify.sanitize(getString(string));
      if(cleanHtml) {
        el.innerHTML = cleanHtml;
      }
    }
  }

  function _isAMASCompatible(state) {
    return state && state.startsWith('Amas');
  }

  // Listener for the ImplicitGrant ajax request
  function onRequestCompleted(xhr) {
    try {
      var jsonResponse = JSON.parse(xhr.responseText);
      if (jsonResponse.httpRedirectLocation !== undefined) {
        window.location.replace(jsonResponse.httpRedirectLocation);
      } else {
        window.location.replace('account-linking-status.html?success=false');
      }
    } catch (ex) {
      window.location.replace('account-linking-status.html?success=false');
    }
  }

  function _getHostName() {
    return window.location.host;
  }

  function getApiUrl() {
    var CDN_API_URL_MAP = {
        'guiana.amazon.com': 'pitangui.amazon.com',
        'echo.amazon.com': 'pitangui.amazon.com',
        'alexa.amazon.com': 'pitangui.amazon.com',
        'seamus.amazon.com': 'layla.amazon.com',
        'seamus.amazon.co.uk': 'layla.amazon.co.uk',
        'seamus.amazon.de': 'layla.amazon.de',
        'brodie.amazon.com': 'layla.amazon.com',
        'brodie.amazon.de': 'layla.amazon.de',
        'pico.amazon.com': 'layla.amazon.com',
        'pico.amazon.co.uk': 'layla.amazon.co.uk',
        'alexa.amazon.co.uk': 'layla.amazon.co.uk',
        'alexa.amazon.de': 'layla.amazon.de',
        'projectdee-ui-gamma.amazon.com': 'pitangui.amazon.com',
        'projectdee-ui-gamma.amazon.co.uk': 'layla.amazon.com',
        'projectdee-ui-gamma.amazon.co.jp': 'alexa.amazon.co.jp',
      },
      host = _getHostName();

    if (CDN_API_URL_MAP[host]) {
      host = CDN_API_URL_MAP[host];
    }

    return 'https://' + host;
  }

  setString('skill-successfully-linked', 'skill_successfully_linked');
  setString('attempting-to-link-skill', 'attempting_to_link_skill');
  setString('unable-to-link-skill', 'unable_to_link_skill');
  setString('please-try-again', 'please_try_again');
  setString('leave-this-page', 'leave_this_page');

  // Interpolate the value of the partner friendly name query variable
  // into the html document.
  var i,
    skillNameElements = document.getElementsByClassName('skillName'),
    query = window.location.search.substring(1),
    hash = window.location.hash.substring(1),
    skillName = findKeyAndReturnValue(query, 'skillName') || '',
    // The state can be in the hash (for implicit grant) or in the query (for auth code grant)
    state =
      findKeyAndReturnValue(hash, 'state') ||
      findKeyAndReturnValue(query, 'state') ||
      '',
    accessToken = findKeyAndReturnValue(hash, 'access_token') || '',
    tokenType = findKeyAndReturnValue(hash, 'token_type') || '',
    expiryTime = findKeyAndReturnValue(hash, 'expires_in') || '',
    vendorId = findKeyAndReturnValue(query, 'vendorId') || '',
    authCode = findKeyAndReturnValue(query, 'code') || '',
    error =
      findKeyAndReturnValue(hash, 'error') ||
      findKeyAndReturnValue(query, 'error') ||
      '',
    successResult = document.getElementById('successResult'),
    pendingResult = document.getElementById('pendingResult'),
    failureResult = document.getElementById('failureResult'),
    request = new XMLHttpRequest(),
    params = '',
    defaultTokenType = 'skillToken';

  for (i = 0; i < skillNameElements.length; ++i) {
    skillNameElements[i].textContent = decodeURIComponent(skillName);
  }

  // If it has the vendorId from a query param, this is an ImplicitGrant response
  // Convert to the auth code style request and listen for ajax response
  if (vendorId !== '') {
    if (expiryTime !== '') {
      params += '&expires_in=' + encodeURIComponent(expiryTime);
    }
    params += '&token_type=';
    if (tokenType !== '') {
      params += encodeURIComponent(tokenType);
    } else {
      params += defaultTokenType;
    }
    if (authCode !== '') {
      params += '&auth_code=' + encodeURIComponent(authCode);
    }
    if (accessToken !== '') {
      params += '&access_token=' + accessToken;
    }
    if (error !== '') {
      params += '&error=' + encodeURIComponent(error);
    }

    // If the state starts with 'Amas' prefix, redirect to the new AlexaMobileActivationService establish API
    // API Review: https://alexaapicentral.corp.amazon.com/#/api-reviews/1f639157-c7e9-4d0f-bb24-9ed537aba1a2
    if (_isAMASCompatible(state)) {
      params += '&vendor_id=' + encodeURIComponent(vendorId);
      window.location.replace(
        getApiUrl() +
          '/api/v1/accountLink/establish?state=' +
          encodeURIComponent(state) +
          params
      );
    } else {
      request.onreadystatechange = function () {
        if (this.readyState === 4) {
          onRequestCompleted(request);
        }
      };

      request.open(
        'GET',
        getApiUrl() +
          '/api/skill/link/' +
          encodeURIComponent(vendorId) +
          '?state=' +
          encodeURIComponent(state) +
          params,
        true
      );
      request.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
      request.send();

      // Display the "Pending Result" variant of this page
      if (successResult && pendingResult && failureResult) {
        successResult.style.display = 'none';
        pendingResult.style.display = 'block';
        failureResult.style.display = 'none';
      }
    }
  } else {
    // Display the "Success Result" or "Failure Result" variant of this
    // page according to value of the "success" URI parameter.
    var success = findKeyAndReturnValue(query, 'success');
    if (successResult && pendingResult && failureResult) {
      if (success === 'true') {
        successResult.style.display = 'block';
        pendingResult.style.display = 'none';
        failureResult.style.display = 'none';
      } else {
        successResult.style.display = 'none';
        pendingResult.style.display = 'none';
        failureResult.style.display = 'block';
      }
    }
  }
})();
